import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { ImportNumbersStatusStore } from 'entities/Phone'
import { runBeforeAddNumber } from 'pages/settings/lib/runBeforeAddNumber'
import { ManageNumbersStore } from 'pages/settings/pages/numbers/ui/ManageNumbers'
import type { IManageNumbersConfig } from 'pages/settings/pages/numbers/ui/ManageNumbers/store/type'

export class NumbersStore {
  private _manageNumbersStore: ManageNumbersStore
  private _importNumbersStatusStore: ImportNumbersStatusStore

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._manageNumbersStore = new ManageNumbersStore(0, () => {}, this._entities)
    this._importNumbersStatusStore = new ImportNumbersStatusStore(this._entities.organizationStore)
    this.init()
  }

  init() {
    this._entities.subscriptionStore.init()
  }

  dispose() {
    this._importNumbersStatusStore.dispose()
  }

  onManageNumbers = (config: IManageNumbersConfig) => {
    this._manageNumbersStore.onManageNumbers(config)
  }

  manageNumberWrapper = (fn: () => void, options?: { skipCanceledCheck?: boolean }) => {
    runBeforeAddNumber(this._entities, fn, {
      checkCanceled: !options?.skipCanceledCheck,
    })
  }

  get usedLicense() {
    if (this._entities.subscriptionStore.numbers) {
      return `${this._entities.subscriptionStore.numbers.used} / ${this._entities.subscriptionStore.numbers.total}`
    }
    return 0
  }

  get usedLicenseDiff() {
    if (this._entities.subscriptionStore.numbers) {
      return (
        this._entities.subscriptionStore.numbers.used -
        this._entities.subscriptionStore.numbers.total
      )
    }
    return 0
  }

  get importNumbersStatus() {
    return this._importNumbersStatusStore.importNumbersStatus
  }
}
